export class RemoveAssessmentRequest {
  constructor(public reportId: number, public assessmentList: number[]) {}
}
